import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ManualLookupRequestV2 } from "./ManualLookupRequestV2";

@Injectable()
export class DataService_MultiStationManualLookupV2 {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	ManualOffenderLookupV2(parms: ManualLookupRequestV2) {
		var postResult$ = new Subject();
		var url = "MultiStation/ManualOffenderLookupV2";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
